export default {
  setDecisionSet: (state, payload) => {
    state.decisionSet = payload
  },
}
